module.exports = __webpack_public_path__ + "img/uservoice-title-mobile.713b8213.svg";